import { render, staticRenderFns } from "./updateDeleteInfoBtnCellRenderer.vue?vue&type=template&id=53ec0651&"
import script from "./updateDeleteInfoBtnCellRenderer.vue?vue&type=script&lang=js&"
export * from "./updateDeleteInfoBtnCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports